import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import City from 'src/store/models/City';
export default {
  props: {
    showCitySwitcher: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      city: null,
      cities: []
    };
  },
  methods: {
    goToCity: function goToCity() {
      if (this.city) {
        if (this.city.is_state) {
          window.location = '/' + this.city.state_slug;
        }
      }
    },
    filterCities: function filterCities(val, update, abort) {
      var _this = this;
      if (val) {
        City.api().get('api/cities', {
          dataKey: 'data',
          params: {
            name: val,
            union_states: true
          }
        }).then(function (result) {
          update(function () {
            if (val === '') {
              _this.cities = [];
            } else {
              _this.cities = City.query().with('state').where(function (construction) {
                return construction.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
              }).orderBy('constructions_count', 'desc').get();
            }
          });
        }).catch(function () {
          abort();
        });
      } else if (this.cities.length) {
        update();
      }
    }
  }
};